const initTock = (id = '') => {
  tock('init', id)
}

const resetTock = () => {
  if (window.tock) {
    window.tock.tockUrl = []
    if (window?.tock?.cleanupPreviousWidgets) window.tock.cleanupPreviousWidgets()
  }
}

export { initTock, resetTock }
